<template>
  <span>
    <!-- 증표 종류 선택 변경 시 무료구분 초기화 -->
    <input
      type="radio"
      v-model="search.iv_caseclsf"
      :value="all_code"
      @change="search.iv_freeclsf = (search.iv_caseclsf != 'B10400' && '')"
      id="all"
      />
    <label for="all">전체</label>

    <span v-for="(item , i) in code.B10000" :key="item.value">
      <div v-if="item.value == 'B10400'" ></div>
      <input
        type="radio"
        v-model="search.iv_caseclsf"
        :value="item.value"
        @change="search.iv_freeclsf = ''"
        :id="item.value"
        class="sch_input"
      />
      <label :for="item.value">{{ item.text}}</label>
      <br class="mobile" v-if=" i == 2 || i == 5 " />
    </span>
    <!-- 무료 구분 선택 시 증표 종류 : 면제(B10400) 선택 되도록 -->
    <select
      v-if="!this.except_code.includes('B10400')"
      v-model="search.iv_freeclsf"
      @change="search.iv_caseclsf = search.iv_freeclsf && 'B10400'"
      >
      <option value="" selected="selected">선택</option>
      <option v-for="item in code.FREECLSF"
              :value="item.value"
              :key="item.value">{{item.text}}</option>
    </select>
  </span>
</template>

<script>
let ui
export default {
  data () {
    return {
      code: {},
      all_code : ''
    }
  },
  created() {
    ui = this.$ui;
  },
  mounted() {
    ui.codeLoad("B10000, FREECLSF", code => {
      this.code = code

      // 제외 코드가 넘어온 경우
      if (this.except_code.length > 0) {
          this.code.B10000 = this.code.B10000.filter(e=> !this.except_code.includes(e.value))

          // 전체 코드 : 증표 종류에서 제외코드 제거 후 #으로 연결
            this.all_code
          = this.search.iv_caseclsf = this.code.B10000.map(e => e.value)
                                                      .filter(e => !this.except_code.includes(e)).join("#")

          this.$emit('select');
      }
    });
  },
  props : {
    search: {
      type: Object, // 데이터
      default: () => ({})  // 이것과 같다 === default: function() { return {} }
    },
    except_code: {
      type: Array, // 데이터
      default: () => ([])  // 이것과 같다 === default: function() { return {} }
    },
  },
}
</script>

